!function(){"use strict";

var BaseClass = (window.Zero && window.Zero.CustomElement) || HTMLElement;

class StickyAtcElement extends BaseClass {
    constructor() {
        super();

        /* Properties from attributes */
        this._hasVariants = this.hasAttribute('data-has-variants');
        this._comingSoon = this.hasAttribute('data-coming-soon');
        this._currentVariantId = this.getAttribute('data-variant-id');
        this._optionNames = [];
        try { this._optionNames = JSON.parse(this.getAttribute('data-option-names') || '[]'); } catch(e) {}

        /* Main button (inside sticky-atc) */
        this._btn = this.querySelector('button.product-form__submit');

        /* Overlay elements — siblings in DOM, not children of <sticky-atc>.
           They're outside because <sticky-atc> has CSS transform which creates
           a containing block that breaks position:fixed on children. */
        this._backdrop = document.querySelector('[data-sticky-backdrop]');
        this._overlay = document.querySelector('[data-sticky-overlay]');
        this._closeBtn = null;
        this._addBtn = null;
        this._priceEl = null;
        this._labelEl = null;
        this._selectedLabel = null;
        this._overlayOpen = false;

        if (this._overlay) {
            this._closeBtn = this._overlay.querySelector('[data-sticky-close]');
            this._addBtn = this._overlay.querySelector('[data-sticky-atc-add]');
            this._priceEl = this._overlay.querySelector('[data-sticky-atc-price]');
            this._labelEl = this._overlay.querySelector('[data-sticky-atc-label]');
            this._selectedLabel = this._overlay.querySelector('[data-sticky-selected-label]');
        }

        /* Parse variant JSON from overlay */
        this._variants = [];
        this._selectedOptions = {};
        if (this._overlay) {
            var jsonEl = this._overlay.querySelector('[data-sticky-variants]');
            if (jsonEl) {
                try { this._variants = JSON.parse(jsonEl.textContent); }
                catch(e) { console.warn('[Sticky ATC] Bad variant JSON'); }
            }
        }

        /* Initialize selected options from default variant */
        this._initSelectedOptions();

        /* Intersection observer — show/hide sticky bar */
        this._initObserver();

        /* Bind all events */
        this._bindEvents();

        console.log('[Sticky ATC] Initialized', this._hasVariants ? '(multi-variant)' : '(single-variant)');
    }

    /* ── Initialization helpers ───────────────────────────────── */

    _initSelectedOptions() {
        if (!this._currentVariantId || this._optionNames.length === 0) return;
        var self = this;
        var defaultV = this._variants.find(function(v) {
            return String(v.id) === String(self._currentVariantId);
        });
        if (defaultV && defaultV.options) {
            for (var i = 0; i < this._optionNames.length; i++) {
                this._selectedOptions[this._optionNames[i]] = defaultV.options[i];
            }
        }
    }

    _initObserver() {
        /* Show sticky ATC by default, hide when main ATC is visible */
        var target = document.querySelector('product-info .product-form__submit')
                  || document.querySelector('product-info product-form');
        if (!target) return;
        var self = this;
        var firstFire = true;
        this._observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    /* Main ATC visible — hide sticky */
                    if (firstFire) {
                        /* First callback: no animation, just set state */
                        firstFire = false;
                        self.classList.remove('shown');
                        self.removeAttribute('style');
                        /* Enable transitions for future toggles */
                        requestAnimationFrame(function() {
                            self.classList.add('can-animate');
                        });
                    } else {
                        self.classList.remove('shown');
                    }
                } else {
                    /* Main ATC not visible — show sticky */
                    if (firstFire) {
                        firstFire = false;
                        /* Already shown via inline styles + HTML class, just enable future animations */
                        requestAnimationFrame(function() {
                            self.removeAttribute('style');
                            self.classList.add('can-animate');
                        });
                    } else {
                        self.classList.add('shown');
                    }
                }
            });
        }, { threshold: 0.1 });
        self._observer.observe(target);
    }

    _bindEvents() {
        var self = this;

        /* Main sticky button click */
        if (this._btn) {
            this._btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                self._onMainBtnClick();
            });
        }

        /* Backdrop click closes overlay */
        if (this._backdrop) {
            this._backdrop.addEventListener('click', function() { self._close(); });
        }

        /* Close button */
        if (this._closeBtn) {
            this._closeBtn.addEventListener('click', function() { self._close(); });
        }

        /* Overlay "Add to bag" button */
        if (this._addBtn) {
            this._addBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                self._onAddClick();
            });
        }

        /* Listen for variant option changes from the main PDP too */
        document.addEventListener('optionvaluechange', function(e) {
            if (e.target && e.target.closest && !e.target.closest('[data-sticky-overlay]')) {
                self._onOptionChange(e.detail);
            }
        });

        /* Listen for variant option changes inside overlay */
        if (this._overlay) {
            this._overlay.addEventListener('optionvaluechange', function(e) {
                self._onOptionChange(e.detail);
            });

            /* Size guide button — dispatch triggersizeguide for sizeguide-modal */
            this._overlay.addEventListener('click', function(e) {
                var sgBtn = e.target.closest('[data-modal-trigger="size-guide"]');
                if (sgBtn) {
                    var guideType = sgBtn.getAttribute('data-size-guide') || '';
                    document.dispatchEvent(new CustomEvent('triggersizeguide', {
                        detail: { type: guideType }
                    }));
                }
            });
        }
    }

    /* ── Button handlers ──────────────────────────────────────── */

    _onMainBtnClick() {
        if (this._comingSoon) return;
        if (this._btn && this._btn.disabled) return;

        /* JOIN WAITLIST — open bottom sheet */
        if (this._btn && this._btn.textContent.trim().toUpperCase().includes('WAITLIST')) {
            if (window.__openWaitlist) window.__openWaitlist();
            return;
        }

        if (this._hasVariants && this._overlay) {
            /* Multi-variant: toggle overlay */
            if (this._overlayOpen) {
                this._close();
            } else {
                this._open();
            }
        } else {
            /* Single variant: add directly via XHR */
            this._addToCart(this._currentVariantId);
        }
    }

    _onAddClick() {
        if (!this._currentVariantId) {
            console.warn('[Sticky ATC] No variant selected');
            return;
        }
        if (this._addBtn && this._addBtn.disabled) return;
        /* JOIN WAITLIST — open bottom sheet */
        if (this._addBtn && this._addBtn.dataset.waitlist) {
            if (window.__openWaitlist) window.__openWaitlist();
            return;
        }
        this._addToCart(this._currentVariantId);
    }

    /* ── Overlay open/close ───────────────────────────────────── */

    _open() {
        if (this._overlayOpen) return;
        if (this._backdrop) this._backdrop.classList.add('active');
        if (this._overlay) this._overlay.classList.add('active');
        /* Hide the main sticky bar so it doesn't bleed through rounded corners */
        this.style.opacity = '0';
        this.style.pointerEvents = 'none';
        this._overlayOpen = true;
        document.body.style.overflow = 'hidden';
    }

    _close() {
        if (!this._overlayOpen) return;
        if (this._backdrop) this._backdrop.classList.remove('active');
        if (this._overlay) this._overlay.classList.remove('active');
        /* Restore the main sticky bar */
        this.style.opacity = '';
        this.style.pointerEvents = '';
        this._overlayOpen = false;
        document.body.style.overflow = '';
    }

    /* ── Variant option change ────────────────────────────────── */

    _onOptionChange(detail) {
        /* Update tracked selection */
        this._selectedOptions[detail.option] = detail.selectedValue;

        /* Find matching variant by comparing each option position */
        var self = this;
        var match = this._variants.find(function(v) {
            return self._optionNames.every(function(name, idx) {
                return v.options[idx] === self._selectedOptions[name];
            });
        });

        if (!match) return;

        this._currentVariantId = match.id;

        /* Update price display */
        if (this._priceEl) {
            this._priceEl.textContent = match.price_formatted;
        }

        /* Update availability + pre-order state */
        if (this._addBtn) {
            var isPreorder = match.preorder_end && new Date(match.preorder_end) > new Date();
            if (!match.available) {
                this._addBtn.disabled = false;
                this._addBtn.dataset.waitlist = 'true';
                if (this._labelEl) this._labelEl.textContent = 'JOIN WAITLIST';
                this._addBtn.classList.remove('button--atc-preorder');
                this._addBtn.classList.add('button--atc-primary');
            } else if (isPreorder) {
                this._addBtn.disabled = false;
                delete this._addBtn.dataset.waitlist;
                if (this._labelEl) this._labelEl.textContent = 'Pre-order';
                this._addBtn.classList.remove('button--atc-primary');
                this._addBtn.classList.add('button--atc-preorder');
            } else {
                this._addBtn.disabled = false;
                delete this._addBtn.dataset.waitlist;
                if (this._labelEl) this._labelEl.textContent = 'ADD TO BAG';
                this._addBtn.classList.remove('button--atc-preorder');
                this._addBtn.classList.add('button--atc-primary');
            }
            /* Also update the main floating sticky button text */
            if (this._btn) {
                var mainLabel = this._btn.querySelector('span');
                if (mainLabel) {
                    if (!match.available) {
                        mainLabel.textContent = 'JOIN WAITLIST';
                    } else if (isPreorder) {
                        mainLabel.textContent = 'PRE-ORDER';
                    } else {
                        mainLabel.textContent = 'ADD TO BAG';
                    }
                }
            }
        }

        /* Update selected variant label (e.g. "Small · Gold") */
        if (this._selectedLabel) {
            this._selectedLabel.textContent = match.title.replace(/ \/ /g, ' \u00B7 ');
        }

        /* Update variant summary line on the sticky bar */
        var summaryEl = this.querySelector('[data-sticky-variant-summary]');
        if (summaryEl) {
            var self2 = this;
            this._optionNames.forEach(function(name) {
                var optSpan = summaryEl.querySelector('[data-sticky-option="' + name + '"]');
                if (optSpan) optSpan.textContent = self2._selectedOptions[name];
            });
        }
    }

    /* ── Add to cart via XHR (bypasses ReBuy's fetch patch) ──── */

    _addToCart(variantId) {
        if (!variantId) { console.warn('[Sticky ATC] No variant ID'); return; }
        if (this._adding) { return; }
        this._adding = true;

        var self = this;
        var startTime = Date.now();

        /* Loading state — wrapper class triggers bag boy GIF via ::after */
        var wrapper = this._overlay
            ? this._overlay.querySelector('.sticky-atc__add-btn.product-card__quick-add--atc')
            : null;
        var scrollWrap = this._overlay
            ? this._overlay.querySelector('.sticky-atc__overlay-scroll')
            : null;
        if (wrapper) wrapper.classList.add('loading');
        if (this._addBtn) this._addBtn.disabled = true;

        /* Let bag boy GIF pop above the overlay (remove overflow clipping) */
        if (this._overlay) this._overlay.style.overflow = 'visible';
        if (scrollWrap) scrollWrap.style.overflow = 'visible';

        /* Ensure GIF plays for minimum time before clearing */
        function clearLoading(minMs, cb) {
            var elapsed = Date.now() - startTime;
            var remaining = Math.max(0, minMs - elapsed);
            setTimeout(function() {
                if (wrapper) wrapper.classList.remove('loading');
                if (self._addBtn) self._addBtn.disabled = false;
                if (self._overlay) self._overlay.style.overflow = '';
                if (scrollWrap) scrollWrap.style.overflow = '';
                self._adding = false;
                if (cb) cb();
            }, remaining);
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
                var item;
                try { item = JSON.parse(xhr.responseText); } catch(e) { item = {}; }
                clearLoading(1500, function() {
                    self._close();
                    if (window.__thryftyOpenCart) window.__thryftyOpenCart();
                });
            } else {
                console.error('[Sticky ATC] HTTP', xhr.status);
                clearLoading(800);
            }
        };

        xhr.onerror = function() {
            console.error('[Sticky ATC] Network error');
            clearLoading(800);
        };

        xhr.send('id=' + encodeURIComponent(variantId) + '&quantity=1');
    }
}

/* Register the custom element */
customElements.define('sticky-atc', StickyAtcElement);

}();
